import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-0 w-full flex gap-2 items-center" }
const _hoisted_2 = ["id", "disabled"]
const _hoisted_3 = ["for"]

import { ref } from "vue";
import { defineEmits } from "@vue/runtime-core";
import { useStore } from "vuex";

export default /*@__PURE__*/_defineComponent({
  __name: 'InputCheckbox',
  props: {
    model: { type: Boolean },
    keyId: {},
    placeholder: {},
    disabled: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const store = useStore();
const props = __props;
let model = ref(props.model);

function customChange(event: any) {
  const x = {
    value: !model.value,
    key: props.keyId,
  };
  emit("change", x);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event)),
      class: "disabled:bg-gray-2 disabled:text-darkGray-2 disabled:cursor-not-allowed",
      type: "checkbox",
      onInput: customChange,
      id: _ctx.keyId,
      disabled: props.disabled ? true : null
    }, null, 40, _hoisted_2), [
      [_vModelCheckbox, _unref(model)]
    ]),
    _createElementVNode("label", {
      class: "text-darkGray-1",
      for: _ctx.keyId
    }, _toDisplayString(_ctx.placeholder), 9, _hoisted_3)
  ]))
}
}

})